import { useState, useEffect } from 'react';

const darkModeQueryString = '(prefers-color-scheme: dark)';

const lightCssProperties = `
  --bgBlueish: hsl(232, 95%, 99%);
  --bgBlueish__text: hsl(232, 95%, 5%);
  --bgBlueish__textDim: hsl(232, 95%, 15%);
  --bgBlueish__tintedText: var(--bgHotBlue);
  --bgBlueish__fadedText: hsl(232, 20%, 75%);

  --bgHotBlue: hsl(232, 95%, 54%);
  --bgHotBlue__text: hsl(232, 95%, 95%);
  --bgHotBlue__dimText: hsl(232, 95%, 88%);
  --bgHotBlue__tintedText: hsl(232, 95%, 15%);

  --bgHotGreen: hsl(173, 98%, 44%);
  --bgHotGreen__text: hsl(173, 50%, 12%);
  --bgHotGreen__dimText: hsl(173, 50%, 25%);
  --bgHotGreen__tintedText: hsl(173, 98%, 44%);

  --bgGreenish: hsl(173, 98%, 98%);
  --bgGreenish__text: hsl(173, 98%, 5%);
  --bgGreenish__textDim: hsl(173, 98%, 15%);
  --bgGreenish__tintedText: var(--bgHotGreen);
`;

const darkCssProperties = `
  --bgBlueish: hsl(232, 40%, 6%);
  --bgBlueish__text: hsl(232, 40%, 80%);
  --bgBlueish__textDim: hsl(232, 40%, 70%);
  --bgBlueish__tintedText: hsl(232, 95%, 70%);
  --bgBlueish__fadedText: hsl(232, 15%, 35%);

  --bgHotBlue: hsl(232, 95%, 23%);
  --bgHotBlue__text: hsl(232, 40%, 80%);
  --bgHotBlue__dimText: hsl(232, 40%, 70%);
  --bgHotBlue__tintedText: hsl(232, 95%, 54%);

  --bgHotGreen: hsl(173, 98%, 20%);
  --bgHotGreen__text: hsl(173, 40%, 70%);
  --bgHotGreen__dimText: hsl(173, 40%, 60%);
  --bgHotGreen__tintedText: hsl(173, 98%, 44%);

  --bgGreenish: hsl(173, 98%, 4%);
  --bgGreenish__text: hsl(173, 40%, 80%);
  --bgGreenish__textDim: hsl(173, 40%, 70%);
  --bgGreenish__tintedText: hsl(173, 95%, 54%);
`;

export function ColorThemeBoundary({ theme = 'auto', children }) {
  return (
    <div className="root">
      {children}
      <style jsx>{`
        .root {
          ${theme === 'light' || theme === 'auto'
            ? lightCssProperties
            : darkCssProperties}
        }

        @media (prefers-color-scheme: dark) {
          .root {
            ${theme === 'auto' && false ? darkCssProperties : ''}
          }
        }
      `}</style>
    </div>
  );
}
